import React from 'react';
import PropTypes from 'prop-types';
import { NavFragment } from '@paypalcorp/globalnavsdk/NavFragment';

export default class Footercontainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <NavFragment type="footer" />;
  }
}

Footercontainer.propTypes = {
  footer: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
};
